import Vue from 'vue'

Vue.filter('numberFormat', function (value) {
  if (!value) return
  return Number(value).toFixed(6)
})
